export default __webpack_public_path__ + "static/media/dinamico.5477bb40.png";